import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=37c5081b&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=ts&"
export * from "./AccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccountModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountModal.vue?vue&type=style&index=1&id=37c5081b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5081b",
  null
  
)

export default component.exports